function getKeyValueFromQueryString(key) {
    var queryString = window.location.search.substring(1);
    var pairs = queryString.split('&');
    for (var i = 0; i < pairs.length; i += 1) {
        var pair = pairs[i].split('=');
        if (decodeURIComponent(pair[0]) === key) {
            return decodeURIComponent(pair[1]);
        }
    }
    return undefined;
}
export default getKeyValueFromQueryString;



//////////////////
// WEBPACK FOOTER
// ./src/imports/getKeyValueFromQueryString.ts
// module id = 471
// module chunks = 0